import { render, staticRenderFns } from "./director-password.vue?vue&type=template&id=3b32ec50&scoped=true&"
import script from "./director-password.vue?vue&type=script&lang=ts&"
export * from "./director-password.vue?vue&type=script&lang=ts&"
import style0 from "./director-password.vue?vue&type=style&index=0&id=3b32ec50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b32ec50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VTextField})
